import { api } from "api";
import React from 'react';
import { Field } from 'redux-form';
import {
    renderNumberG,
    renderTimeField,
    AsyncSelectField,
} from '../../../../Utils/renderField/renderField';
import Modal from 'react-responsive-modal';
import { NotificationManager } from "react-notifications";
import { calcularDRCLatex } from "../../../../Utils/LaboratorioDRC/CalculosDRCLatex";
import { aplicarVariacionDRC } from "../../../../Utils/LaboratorioDRC/Common";

/**
 * Función para obtener los laboratoristas de latex
 * @param {*} search Laboratorista a buscar
 * @returns {Promise} Promise con los laboratoristas
 */
const getLaboratoristasLatex = search => {
    return api.get('laboratorista/listar_laboratoristas_latex', { search })
        .then(data => {
            if (data) {
                return data.results;
            }
            return [];
        }).catch(() => ([]));
}

/**
 * Componente para renderizar el modal de DRC
 * Se creó para refactorizar el contenido en el componente general (LaboratorioForm)
 * Solo se hicieron cambios respectivos a la variación DRC
 * @param {object} props propiedades del componente
 * @returns {JSX.Element} componente de modal de DRC
 */
export const ModalDRC = (props) => {
    const { fields, setDRCTemp, drc_temporal, clearDRCTemp, closeModal, open_drc,
        updateData, variacionDRC } = props;

    return (
        <Modal open={open_drc} onClose={() => { closeModal() }} closeOnEsc={false} closeOnOverlayClick={false}>
            <h2>DATOS DRC</h2>
            <div className="row p-0">
                <div className="col-12">
                    <div className="row p-0">
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_seco_original" className="m-0">PESO SECO</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_seco_original" component={renderNumberG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_seco_original'], onChange: (e) => {
                                            setDRCTemp('peso_seco_original', parseFloat(e));
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_plato" className="m-0">PESO PLATO</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_plato" component={renderNumberG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_plato'], onChange: (e) => {
                                            setDRCTemp('peso_plato', parseFloat(e));
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="peso_humedo" className="m-0">PESO HÚMEDO</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="peso_humedo" component={renderNumberG} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['peso_humedo'], onChange: (e) => {
                                            setDRCTemp('peso_humedo', parseFloat(e));
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="hora_ingreso" className="m-0">HORA INGRESO</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="hora_ingreso" component={renderTimeField} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['hora_ingreso'], onChange: (e) => {
                                            setDRCTemp('hora_ingreso', e);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="hora_salida" className="m-0">HORA SALIDA</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field name="hora_salida" component={renderTimeField} type="text"
                                    className="form-control"
                                    input={{
                                        value: drc_temporal['hora_salida'], onChange: (e) => {
                                            setDRCTemp('hora_salida', e);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-4 p-0">
                            <div className="col-md-12 col-sm-12">
                                <label htmlFor="laboratorista" className="m-0">LABORATORISTA</label>
                            </div>
                            <div className="col-md-12  form-group">
                                <Field
                                    name="laboratorista"
                                    valueKey="id"
                                    labelKey="nombre"
                                    label="nombre"
                                    component={AsyncSelectField}
                                    // loadOptions={getUsuarios}
                                    loadOptions={getLaboratoristasLatex}
                                    input={{
                                        value: drc_temporal['laboratorista'], onChange: (e) => {
                                            setDRCTemp('laboratorista', e);
                                            setDRCTemp('laboratorista_nombre', e.nombre);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="buttons-box mt-5">
                <button className="btn btn-outline-dark mr-5"
                    onClick={e => {
                        e.preventDefault();
                        closeModal()
                    }}>
                    CANCELAR
                </button>
                <button type="submit" className="btn btn-primary"
                    onClick={(e) => {
                        e.preventDefault();
                        if (!drc_temporal.peso_seco_original) {
                            NotificationManager.error('Ingrese el peso seco.', 'ERROR', 3000);
                        }
                        if (!drc_temporal.peso_plato) {
                            NotificationManager.error('Ingrese el peso plato.', 'ERROR', 3000);
                        }
                        if (!drc_temporal.peso_humedo) {
                            NotificationManager.error('Ingrese el peso húmedo.', 'ERROR', 3000);
                        }
                        if (!drc_temporal.hora_ingreso) {
                            NotificationManager.error('Ingrese la hora de ingreso.', 'ERROR', 3000);
                        }
                        if (!drc_temporal.laboratorista) {
                            NotificationManager.error('Ingrese el laboratorista', 'ERROR', 3000);
                        }

                        if (drc_temporal.peso_seco_original && drc_temporal.peso_plato && drc_temporal.peso_humedo && drc_temporal.hora_ingreso && drc_temporal.laboratorista) {
                            // Aplicar variación DRC a peso seco
                            if (variacionDRC.aplica) {
                                drc_temporal.peso_seco = aplicarVariacionDRC(drc_temporal.peso_seco_original, variacionDRC.variacion);
                            } else {
                                drc_temporal.peso_seco = drc_temporal.peso_seco_original;
                            }

                            if (drc_temporal.peso_seco && drc_temporal.peso_plato && drc_temporal.peso_humedo) {
                                drc_temporal.total = calcularDRCLatex(drc_temporal);
                            }

                            if (drc_temporal.hasOwnProperty('index'))
                                updateData(drc_temporal, 'drc');
                            else
                                fields.push(drc_temporal);
                            clearDRCTemp();
                            closeModal();
                        }
                    }}
                >
                    GUARDAR
                </button>
            </div>
        </Modal>
    )
};
